import { toPng } from 'html-to-image';

// Kartı PNG olarak indirir (İzin Paneli'nin aynısı). data-export-exclude işaretli öğeler (indirme / tablo düğmeleri)
// görüntüye girmez; arka plan sayfa renginden bağımsız beyaz.
export async function exportCardPng(node, cardKey) {
  if (!node) return;
  const dataUrl = await toPng(node, {
    backgroundColor: '#FFFFFF',
    pixelRatio: 2,
    filter: (child) => !(child.dataset && child.dataset.exportExclude !== undefined),
  });
  const link = document.createElement('a');
  link.download = `devam-paneli-${cardKey}-${new Date().toISOString().slice(0, 10)}.png`;
  link.href = dataUrl;
  link.click();
}
